import React from 'react';

import NwDrawer from '@components/Gui/NwDrawer';

import SendProjectDrawerContent from './SendProjectDrawerContent';
import { SendProjectDrawerProvider } from './SendProjectDrawerContext';

/**
 * Main SendProjectDrawer component with Context Provider
 * Wraps the content with the SendProjectDrawerProvider to provide state management
 */
const SendProjectDrawer = ({ currentProject, ModelID, EventID, EventType, onClose }) => {
    return (
        <SendProjectDrawerProvider>
            <NwDrawer
                title="Send schedule by e-mail"
                onClose={onClose}
                width="80vw"
                maxWidth="960px"
                padding="0"
                id="send-project-drawer"
            >
                <SendProjectDrawerContent
                    currentProject={currentProject}
                    ModelID={ModelID}
                    EventID={EventID}
                    EventType={EventType}
                    onClose={onClose}
                />
            </NwDrawer>
        </SendProjectDrawerProvider>
    );
};

export default SendProjectDrawer;
